import script from "./RainbowShootController.vue?vue&type=script&setup=true&lang=js"
export * from "./RainbowShootController.vue?vue&type=script&setup=true&lang=js"

import "./RainbowShootController.vue?vue&type=style&index=0&id=21755272&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21755272"]])

export default __exports__